import { render, staticRenderFns } from "./PaymentBadge.vue?vue&type=template&id=86d6c054"
import script from "./PaymentBadge.vue?vue&type=script&lang=js"
export * from "./PaymentBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d6c054')) {
      api.createRecord('86d6c054', component.options)
    } else {
      api.reload('86d6c054', component.options)
    }
    module.hot.accept("./PaymentBadge.vue?vue&type=template&id=86d6c054", function () {
      api.rerender('86d6c054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/PaymentBadge.vue"
export default component.exports